/**
 * W7h — « Réaffecter » un appel d'offres : le CHARGÉ DE RÉPONSE et/ou le RESPONSABLE DU
 * MARCHÉ (demande du PO du 2026-09-22).
 *
 * La masse n'offrait qu'un « Nouveau responsable », sans dire lequel des trois responsables
 * d'un marché elle changeait. Elle change désormais l'un, l'autre ou les deux ; le contact
 * administratif du compte appartient au CLIENT et se change sur la fiche client, ou en masse
 * depuis la liste des Clients.
 *
 * Ce module porte le SEUL passage de l'écran au corps de `POST /tenders/bulk` : l'exécution
 * (`useBulkReassignTenders`) et l'aperçu (la modale, via `refreshImpact`) l'empruntent tous
 * deux, pour que le nombre annoncé réponde exactement au choix qui sera appliqué.
 */

/** Les personnes choisies, rôle par rôle. Un rôle absent ne change pas. */
export interface CiblesDeReaffectation {
    /** Le chargé de réponse (`owner_id`). */
    newOwnerId?: string | null
    /** Le responsable du marché (`market_manager_id`). */
    newMarketManagerId?: string | null
}

/**
 * Les `params` de l'action `reassign`, avec les SEULS rôles choisis.
 *
 * ⚠️ Un rôle non choisi n'est pas envoyé du tout : le serveur ne vide jamais un rôle, mais
 * un `null` qui partirait ici serait lu « personne » par le premier qui changerait ce
 * contrat. `new_owner_id` seul est l'ancien corps : il reste valide tel quel.
 */
export function parametresDeReaffectation(cibles: CiblesDeReaffectation): Record<string, string> {
    return {
        ...(cibles.newOwnerId ? { new_owner_id: cibles.newOwnerId } : {}),
        ...(cibles.newMarketManagerId ? { new_market_manager_id: cibles.newMarketManagerId } : {}),
    }
}
